module.exports = __webpack_public_path__ + "img/559-42dfb3.png";